import canvasEnums from '../enums/canvas';

export function getPanelYAxisLeftStyles() {
	return {
		yAxis: {
			label: {
				textAlign: canvasEnums.textAlign.RIGHT
			}
		},
		padding: {
			left: 50,
			right: 0
		}
	};
}
